import React from "react";
import contactinfoimg1 from "../assets/images/contact-info-img-1.jpg";
import contactinfoimg2 from "../assets/images/contact-info-img-2.jpg";
import iconmail from "../assets/images/icon-mail.svg";
import contactusimg from "../assets/images/contact-us-img.jpg";
import iconphone from "../assets/images/icon-phone.svg";
import iconlocation from "../assets/images/icon-location.svg";

function contact() {
  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              {/* Page Header Box Start */}
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  Contact us
                </h1>
                <nav className="wow fadeInUp">
                  {/* <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="./">home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  contact us
                </li>
              </ol> */}
                </nav>
              </div>
              {/* Page Header Box End */}
            </div>
          </div>
        </div>
      </div>
      {/* Page Header End */}
      {/* Page Contact Us Start */}
      <div className="page-contact-us">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              {/* Conatct Info Item Start */}
              <div className="contact-info-item wow fadeInUp">
                <div className="contact-info-img">
                  <figure className="image-anime">
                    <img src={contactinfoimg1} alt="contactinfoimg1" />
                  </figure>
                </div>
                <div className="contact-info-body">
                  <div className="icon-box">
                    <img src={iconphone} alt="iconphone" />
                  </div>
                  <div className="contact-info-content">
                    <h3>call us any time!</h3>
                    <p>
                      <a href="tel:9079132001">
                        +91-9079132001
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              {/* Conatct Info Item End */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Conatct Info Item Start */}
              <div
                className="contact-info-item wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="contact-info-img">
                  <figure className="image-anime">
                    <img src={contactinfoimg2} alt="contactinfoimg2" />
                  </figure>
                </div>
                <div className="contact-info-body">
                  <div className="icon-box">
                    <img src={iconmail} alt="iconmail" />
                  </div>
                  <div className="contact-info-content">
                    <h3>send us e-mail</h3>
                    <p>sales@Click4pay.com</p>
                  </div>
                </div>
              </div>
              {/* Conatct Info Item End */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Conatct Info Item Start */}
              <div
                className="contact-info-item wow fadeInUp"
                data-wow-delay="0.4s"
              >
                <div className="contact-info-img">
                  <figure className="image-anime">
                    <img src={contactinfoimg1} alt="contactinfoimg1" />
                  </figure>
                </div>
                <div className="contact-info-body">
                  <div className="icon-box">
                    <img src={iconlocation} alt="iconlocation" />
                  </div>
                  <div className="contact-info-content">
                    <h3>finance office address</h3>
                    <p>
                   Kartarpura, Jaipur (Raj.)- 302006

                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-form-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="contact-form-img">
                <figure className="image-anime reveal">
                  <img src={contactusimg} alt="contactusimg" />
                </figure>
              </div>
            </div>
            <div className="col-lg-6">
              {/* Section Title Start */}
              <div className="section-title">
                <h3 className="wow fadeInUp">contact us</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Get in Touch <span>with Us</span>
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.2s">
                  Have questions or need assistance? Reach out to us today!
                  We're here to provide expert solutions and friendly support.
                </p>
              </div>
              {/* Section Title End */}
              <div className="contact-form">
                {/* Contact Form Start */}
                <form
                  id="contactForm"
                  action="#"
                  method="POST"
                  data-toggle="validator"
                  className="wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <div className="row">
                    <div className="form-group col-md-6 mb-4">
                      <input
                        type="text"
                        name="fname"
                        className="form-control"
                        id="fname"
                        placeholder="First name"
                        required=""
                      />
                      <div className="help-block with-errors" />
                    </div>
                    <div className="form-group col-md-6 mb-4">
                      <input
                        type="text"
                        name="lname"
                        className="form-control"
                        id="lname"
                        placeholder="Last name"
                        required=""
                      />
                      <div className="help-block with-errors" />
                    </div>
                    <div className="form-group col-md-6 mb-4">
                      <input
                        type="text"
                        name="phone"
                        className="form-control"
                        id="phone"
                        placeholder="Phone no"
                        required=""
                      />
                      <div className="help-block with-errors" />
                    </div>
                    <div className="form-group col-md-6 mb-4">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        id="email"
                        placeholder="E-mail address"
                        required=""
                      />
                      <div className="help-block with-errors" />
                    </div>
                    <div className="form-group col-md-12 mb-5">
                      <textarea
                        name="message"
                        className="form-control"
                        id="message"
                        rows={4}
                        placeholder="Message"
                        defaultValue={""}
                      />
                      <div className="help-block with-errors" />
                    </div>
                    <div className="col-md-12">
                      <button type="submit" className="btn-default">
                        send message
                      </button>
                      <div id="msgSubmit" className="h3 hidden" />
                    </div>
                  </div>
                </form>
                {/* Contact Form End */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Contact Form Section End */}
      {/* Google Map Start */}
      <div className="google-map">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* Google Map Start */}
              <div className="google-map-iframe">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d33604.01481709765!2d75.77989891364261!3d26.88179277483573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db4389ca5ba5b%3A0xee69d6dcb2f846fc!2sKartarpur%2C%20Gopal%20Pura%20Mode%2C%20Jaipur%2C%20Rajasthan!5e1!3m2!1sen!2sin!4v1764917832278!5m2!1sen!2sin"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              {/* Google Map End */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default contact;
